@import "../../../../styles/base";

/*
  Variants:
*/

.primary {
  background: var(--primary-button-background);
  color: var(--primary-button-colour);
  border-color: transparent;

  &.disabled {
    background-color: $ds-neutral-50;
    color: $ds-neutral-300;
    cursor: default;
  }
}

.primary:hover:not(.disabled),
.primary:global(:focus-visible) {
  background-color: var(--primary-button-hover-background);
  color: var(--primary-button-colour);
}

.secondary {
  border-color: transparent;
  background-color: var(--secondary-button-background);
  color: var(--secondary-button-colour);

  &.disabled {
    background-color: var(--secondary-button-disabled-background);
    color: var(--secondary-button-disabled-colour);
    cursor: default;
  }
}

.secondary:hover:not(.disabled),
.secondary:global(:focus-visible) {
  background-color: var(--secondary-button-hover-background);
  color: var(--secondary-button-hover-colour);
}

.danger {
  border-color: transparent;
  background-color: $ds-coral-600;
  color: $white;

  &.disabled {
    background-color: $ds-neutral-50;
    color: $ds-neutral-300;
    cursor: default;
  }
}

.danger:hover:not(.disabled),
.danger:global(:focus-visible) {
  background-color: $ds-coral-900;
  color: $white;
}

.placeholder {
  border: 2px dashed $ds-neutral-200;
}

.placeholder:hover:not(.disabled),
.placeholder:global(:focus-visible) {
  background-color: $ds-neutral-100;
  color: $ds-violet-900;
}

/*
  Flags:
*/

.active,
.highlight {
  background-color: var(--secondary-button-highlight-background);
  color: var(--secondary-button-highlight-colour);

  &:hover:not(.disabled),
  &:global(:focus-visible) {
    background-color: var(--secondary-button-highlight-hover-background);
    color: var(--secondary-button-highlight-hover-colour);
  }
}

// We use a class for disabled because sometimes we have (eg) links styled to look like buttons, or spans styled to look like disabled "link buttons", and you can't disable a span.
.disabled {
  opacity: 0.5;
  cursor: default;
}
